import { render } from "./CreateFaqModal.vue?vue&type=template&id=60ca8965&scoped=true"
import script from "./CreateFaqModal.vue?vue&type=script&lang=js"
export * from "./CreateFaqModal.vue?vue&type=script&lang=js"

import "./CreateFaqModal.vue?vue&type=style&index=0&id=60ca8965&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ca8965"]])

export default __exports__